//http://zgp.phasercn.com:4999/web/#/7?page_id=168

import request from "@utils/request";

/*
 * 兑换游戏积分
 * */
export function transfer_gamecoin(data) {
  return request.post("/transfer_gamecoin", data);
}

// game/get_gift

export function get_gift(data) {
  return request.post("/game/get_gift", data);
}

//game/big_wheel

export function big_wheel(data) {
  return request.post("/game/big_wheel", data);
}

export function game5_config(data) {
  return request.post("/game5/config", data);
}

export function game5_throwKnife(data) {
  return request.post("/game5/throwKnife", data);
}

export function game5_success(data) {
  return request.post("/game5/success", data);
}
export function game5_fail(data) {
  return request.post("/game5/fail", data);
}


export function game7_config(data) {
  return request.post("/game7v2/config", data);
}

export function game7_start(data) {
  return request.post("/game7v2/start", data);
}
export function game7_end(data) {
  return request.post("/game7v2/end", data);
}

export function game9_config(data) {
  return request.post("/game9/config", data);
}

export function game9_start(data) {
  return request.post("/game9/start", data);
}
export function game9_end(data) {
  return request.post("/game9/end", data);
}

export function game10_config(data) {
  return request.post("/game10/config", data);
}

export function game10_start(data) {
  return request.post("/game10/start", data);
}
export function game10_end(data) {
  return request.post("/game10/end", data);
}

export function game11_config(data) {
  return request.post("/game11/config", data);
}

export function game11_start(data) {
  return request.post("/game11/start", data);
}
export function game11_end(data) {
  return request.post("/game11/end", data);
}